module.exports = __webpack_public_path__ + "static/media/sf_2600.6f5e5dd7c05c5c84a0d9976fdc446921.png";